import { createElement, useRef, useState } from 'react';
import { Calendar, DatePicker } from '@nutui/nutui-react';
import cls from 'classnames/bind';
import style from './index.module.scss';
import { Alarm } from '@nutui/icons-react';
import dayjs from 'dayjs';
import { Button } from '@nutui/nutui-react';
const cx = cls.bind(style);
const RangePreset = {
    上月: [
        dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    ],
    本月: [
        dayjs().startOf('month').format('YYYY-MM-DD'),
        dayjs().endOf('month').format('YYYY-MM-DD'),
    ],
    下月: [
        dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
        dayjs().add(1, 'month').endOf('month').format('YYYY-MM-DD'),
    ],
};
const padZero = (num, targetLength = 2) => {
    let str = `${num}`;
    while (str.length < targetLength) {
        str = `0${str}`;
    }
    return str;
};
const btns = ['上月', '本月', '下月'];
const MobleTimeDateRangePicker = (props) => {
    const { value, onChange, name } = props;
    const [date, setDate] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const calendarRef = useRef(null);
    const [show, setShow] = useState(false);
    const [dpAbled, setDatePickerAbled] = useState([false, false]);
    const [desc1, setDesc1] = useState('00:00:00');
    const [desc2, setDesc2] = useState('00:00:00');
    const desc = useRef(0);
    const defaultValue = new Date();
    const defaultDescription = `${defaultValue.getFullYear()}-${defaultValue.getMonth() + 1}-${defaultValue.getDate()}`;
    const [curTime, setCurTime] = useState('');
    const setChooseValue = (chooseData) => {
        const dateArr = [...[chooseData[0][3], chooseData[1][3]]];
        setDate([...dateArr]);
        const time1 = dateArr[0].replace(/\//g, '-') + ` ${desc1}`;
        const time2 = dateArr[1].replace(/\//g, '-') + ` ${desc2}`;
        onChange([time1, time2]);
    };
    const confirm = (values, options) => {
        if (desc.current === 1) {
            setDesc1(options.map((option) => padZero(parseInt(option.text))).join(':'));
        }
        else {
            setDesc2(options.map((option) => padZero(parseInt(option.text))).join(':'));
        }
    };
    const showDatePicker = (e, index) => {
        if (dpAbled[index - 1]) {
            e.stopPropagation();
            setCurTime(new Date(`${defaultDescription} ${index === 1 ? desc1 : desc2}`));
            setShow(true);
            desc.current = index;
        }
    };
    const openSwitch = () => {
        setIsVisible(true);
    };
    const closeSwitch = () => {
        setIsVisible(false);
    };
    const getCurentMonth = (type) => {
        const dates = RangePreset[type];
        setDate(dates);
        setDesc1('00:00:00');
        setDesc2('23:59:59');
        setDatePickerAbled([true, true]);
        if (calendarRef.current) {
            calendarRef.current.scrollToDate(dates[0]);
        }
    };
    const renderHeaderButtons = () => {
        return (createElement("div", null, btns.map((item) => (createElement("span", { className: "d_btn", onClick: () => getCurentMonth(item) },
            createElement(Button, { fill: "outline", color: "#3F9BE6", size: "mini", style: {
                    margin: 8,
                } }, item))))));
    };
    return (createElement(React.Fragment, null,
        createElement("div", { className: cx('triger'), onClick: openSwitch },
            name,
            createElement(Alarm, null)),
        createElement(Calendar, { ref: calendarRef, visible: isVisible, defaultValue: date, type: "range", startDate: "2022-01-01", firstDayOfWeek: 1, onDayClick: (date) => {
                let d = [false, false];
                if (date.length > 1) {
                    d = [true, true];
                }
                else if (date.length > 0) {
                    d = [true, false];
                }
                setDatePickerAbled(d);
            }, onClose: closeSwitch, onConfirm: setChooseValue, renderHeaderButtons: renderHeaderButtons },
            createElement("div", { className: cx('nut-calendar-btns') },
                createElement("div", { className: `nut-calendar-date ${dpAbled[0] ? '' : cx('disabled')}`, onClick: (e) => {
                        showDatePicker(e, 1);
                    } },
                    "\u5F00\u59CB\u65F6\u95F4\uFF1A",
                    desc1),
                "-",
                createElement("div", { className: `nut-calendar-date ${dpAbled[1] ? '' : cx('disabled')}`, onClick: (e) => {
                        showDatePicker(e, 2);
                    } },
                    "\u7ED3\u675F\u65F6\u95F4\uFF1A",
                    desc2)),
            createElement(DatePicker, { title: "\u65F6\u95F4\u9009\u62E9", type: "time", visible: show, showChinese: true, onClose: () => setShow(false), onConfirm: (options, values) => confirm(values, options), value: curTime }))));
};
export default MobleTimeDateRangePicker;
